import React, { PropTypes } from 'react';
import BestPlayerVoting from '../../../../../api/voting/bestPlayer';
import FullDatePicker from '../../../../form/FullDatePicker';
import ErrorContainer from '../../../../form/ErrorContainer';
import PlayersSelectList from '../../../../Players/PlayersSelectList';
import VotingToolBar from '../VotingToolBar';
import VotingBaseForm from '../VotingBaseForm';

class BestPlayerVotingForm extends VotingBaseForm {
  static propTypes = {
    model: PropTypes.instanceOf(BestPlayerVoting),
    fields: PropTypes.shape({
      players: PropTypes.object.isRequired,
      voting: PropTypes.object.isRequired,
      start_time: PropTypes.object.isRequired,
      end_time: PropTypes.object.isRequired
    }),
    disabled: PropTypes.bool
  };

  render() {
    let {
          fields: {players, start_time, end_time, voting},
          disabled = false
        } = this.props;

    return (
      <div>
        <ErrorContainer id="event_best_player_voting" displayLabel={false} error={voting.error} touched={true} style={{margin:0}}/>
        <PlayersSelectList label="Select players" disabled={disabled} {...players}/>
        <FullDatePicker label="Start time" required disabled={disabled} {...start_time}/>
        <FullDatePicker label="End time" min={start_time.value} required disabled={disabled} {...end_time}/>
        <VotingToolBar {...this.getToolbarOptions()}/>
      </div>
    );
  }
}

export default BestPlayerVotingForm;




// WEBPACK FOOTER //
// ./src/components/Events/EventsEditForm/votings/BestPlayerVoting/BestPlayerVoting.jsx